import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Добавление контейнера",
    overflow: false,
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_select, {
        value: _ctx.state.sectorId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.sectorId) = $event)),
        placeholder: "Сектор",
        "error-text": "При получении секторов произошла ошибка",
        options: _ctx.data_state.sectors.list,
        loading: _ctx.data_state.sectors.is_loading,
        failed: _ctx.data_state.sectors.is_failed,
        disabled: _ctx.loading,
        "is-invalid": _ctx.state_form$.sectorId.$error,
        "validation-errors": _ctx.state_form$.sectorId.$errors,
        onRefresh: _ctx.loadSectors
      }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors", "onRefresh"]),
      _createVNode(_component_new_select, {
        class: "mt-3",
        value: _ctx.state.cargoType,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.cargoType) = $event)),
        placeholder: "Тип",
        "search-without-refresh": "",
        options: _ctx.CARGO_TYPES,
        disabled: _ctx.loading,
        searchable: false,
        "is-invalid": _ctx.state_form$.cargoType.$error,
        "validation-errors": _ctx.state_form$.cargoType.$errors
      }, null, 8, ["value", "options", "disabled", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}